<template>
  <div class="beethoven-inline-embed" :style="{ 'background-color': previewImageColor }">
    <div
      class="beethoven-inline-embed-container"
      :style="{ 'background-color': previewImageColor }"
      :data-aspect-ratio="previewImageAspectRatio"
      v-html="embedHtml"
    />
    <div
      class="beethoven-inline-embed-actions"
      :style="{ 'background-color': previewImageColor, height: embedMetaHeight + 'px' }"
      :data-luminance="previewImageLuminance"
    >
      <div class="button-list">
        <button class="icon-button" :title="__('Back to preview')" @click="backToPreview">
          <base-icon name="arrow_back" />
        </button>
      </div>
      <div v-if="!actionable" class="button-list">
        <button class="icon-button" :title="__('Zoom')" @click="zoom">
          <base-icon name="zoom_in" />
        </button>
        <a
          v-if="isDownloadable"
          target="_blank"
          :download="title"
          :href="downloadUrl"
          class="icon-button"
          draggable="false"
          :title="__('Download')"
        >
          <base-icon name="download" />
        </a>
        <a :href="currentUrl" target="_blank" class="icon-button" draggable="false" :title="__('Open in new window')">
          <base-icon name="open_in_new" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { trackEvent } from 'bits/analytics'
import BaseIcon from 'vuecomponents/base_icon'
import { downloadUrl } from 'bits/attachments'

export default {
  components: { BaseIcon },
  props: [
    'actionable',
    'title',
    'currentUrl',
    'isDownloadable',
    'previewImageColor',
    'previewImageAspectRatio',
    'previewImageLuminance',
    'embedHtml',
    'embedMetaHeight',
  ],
  data() {
    return {}
  },
  computed: {
    downloadUrl() {
      return downloadUrl(this.currentUrl)
    },
  },
  methods: {
    backToPreview() {
      this.$emit('back')
    },
    zoom() {
      this.$emit('zoom')
    },
  },
}
</script>
